// extracted by mini-css-extract-plugin
export default {"productGallery":"DF-z","inQuickShop":"EF-z"};